
import Vue from "vue";
import { CompanyService } from "@/services/company-service";
import { AuthService } from "@/services/auth-service";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppDossierList from "@/components/settings-default/DossierList.vue";

export default Vue.extend({
	data(){
		return {
			originalUrl: "",
			workspaceUrl: "",
			error: ""
		};
	},
	computed: {
		path():IBreadCrumb[]{
			return [{
				to: "/settings", value: this.$ct("general")
			},      {value: this.$ct("account")}] as IBreadCrumb[];
		}
	},
	watch: {
		workspaceUrl(){
			if (this.originalUrl == this.workspaceUrl){
				this.error = "";
				return;
			}
			if (this.workspaceUrl == ""){
				this.error = "";
				return;
			}
			this.checkUrlIsAvailable();
		}
	},
	methods: {
		async updateWorkspaceUrl(){
			await CompanyService.setWorkspaceName(this.workspaceUrl);
			if (AuthService.wfCompany){
				AuthService.wfCompany.WorkspaceURL = this.workspaceUrl;
			}
			this.originalUrl = this.workspaceUrl;
			this.$router.push("/settings");
		},
		async checkUrlIsAvailable(){
			try{
				await CompanyService.isWorkspaceNameAvailable(this.workspaceUrl);
				this.error = "";
			}catch(err:any){
				this.error = this.$ct(err.message).toString();
			}
		}
	},
	async created(){
		if (AuthService.wfCompany){
			this.originalUrl  = AuthService.wfCompany.WorkspaceURL || "";
			this.workspaceUrl = this.originalUrl;
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppDossierList
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
